import { FC } from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'

import { Loading } from '../loading'
import { LottieAnimationName } from '../lotties'

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`

const AnimatedLoadingContainer = styled(motion.div)`
    height: fit-content;
    justify-self: center;
    align-self: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

interface Props {
    text: string
    isLoading: boolean
}

export const LoadingContainer: FC<Props> = (props) => {
    const opacityDuration = 0.5
    const initialLoadingOpacity = 0
    const animateLoadingOpacity = props.isLoading ? 1 : 0

    return (
        <AnimatedLoadingContainer
            initial={{ opacity: initialLoadingOpacity }}
            animate={{
                opacity: animateLoadingOpacity,
                transitionEnd: {
                    display: props.isLoading ? 'flex' : 'none',
                },
            }}
            transition={{ duration: opacityDuration }}
        >
            <Loading
                name={LottieAnimationName.LoadSpinner}
                width="100px"
                message={props.text}
            />
        </AnimatedLoadingContainer>
    )
}
